var map = {
	"./pr-1.png": "8844",
	"./pr-10.png": "570b",
	"./pr-11.png": "081b",
	"./pr-2.png": "ff86",
	"./pr-3.png": "fe42",
	"./pr-4.png": "4baf",
	"./pr-5.png": "ced2",
	"./pr-6.png": "c645",
	"./pr-7.png": "c2ab",
	"./pr-8.png": "e0e3",
	"./pr-9.png": "c61b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd01";